import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "./Button";
import { strings } from "../utils";

const ModalScreen = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  certificate,
  confirmButtonText,
  cancelButtonText,
  icon: Icon = null,
  confirmButtonClasses = "",
  cancelButtonClasses = "",
  linkIcon: LinkIcon = null,
  download,
  hideClass
}) => {
  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 4,
          width: 400
        }
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <div className="flex flex-col pt-2 gap-y-[16px]">
          {Icon && <Icon />}
          {title}
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
          <div className={`flex items-center gap-x-1 mt-4 ${hideClass}`}>
            {LinkIcon && <LinkIcon />}
            <p className="text-black">{certificate}</p>
            {download ? (
              <a
                href={download}
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                <Button variant="underlineBold" className="text-primary">
                  {strings["downloadBtn"]}
                </Button>
              </a>
            ) : (
              <p className="text-color-1">Certificate not available</p>
            )}
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className="flex space-x-3 w-full px-4 pb-4">
          <div className="flex w-1/2 text-center">
            <Button
              variant="outlineArrow"
              classes={`!w-full justify-center ${cancelButtonClasses}`} // Apply passed class to cancel button
              onClick={onClose}
            >
              {cancelButtonText}
            </Button>
          </div>
          <div className="flex w-1/2 text-center">
            <Button
              classes={`!w-full justify-center text-white bg-red-500 hover:bg-red-700 ${confirmButtonClasses}`} // Apply passed class to confirm button
              variant="dafault"
              onClick={onConfirm}
            >
              {confirmButtonText}
            </Button>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ModalScreen;
